import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'




export default function OnespAccountInfoComponent({ handleBasicFormChange,handleInnerFormChange, selectedOnesp, accounts }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

 <InputContainer
              label="ONE Service Provider Code"
              name="ONEServiceProviderCode"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.ONEServiceProviderCode',
                  selectedOnesp?.ONEServiceProviderCode
                )
              }}
              type="text"
              value={selectedOnesp?.Account?.ONEServiceProviderCode}
            />

            <InputContainer
              label="Person Account"
              name="IsPersonAccount"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'Account.IsPersonAccount',
                  selectedOnesp?.Account
                )
              }}
              type="checkbox"
              value={selectedOnesp?.Account?.IsPersonAccount}
            />

        
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.Name',
                  selectedOnesp?.Account
                )
              }}
              type="text"
              value={selectedOnesp?.Account?.Name}
            />

            <InputContainer
              label="Number Of Vehicles"
              name="NumberOfVehicles"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Account.NumberOfVehicles',
                  selectedOnesp?.Account
                )
              }}
              type="number"
              value={selectedOnesp?.Account?.NumberOfVehicles}
            />







          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Account Info"
      />

    </>
  )
}